import React, { useEffect, useRef } from "react";
import axios from "../../utills/api";
import { useNotifications } from "../Context/NotificationContext";

const GlobalNotificationWatcher = () => {
  const { addNotification } = useNotifications();
  const audioRef = useRef(new Audio("/notification.mp3"));

  // Track last counts for each service
  const lastCounts = useRef({
    food: 0,
    dine: 0,
    housekeeping: 0,
    spa: 0,
    wellness: 0,
    taxi: 0,
    emergency: 0,
    complaint: 0,
  });

  // Play sound
  const playSound = () => {
    try {
      audioRef.current.play().catch(() => {
        console.warn("User interaction required to play sound");
      });
    } catch (err) {
      console.error("Error playing notification sound:", err);
    }
  };

  // Check for new service requests
  const checkNewRequests = async () => {
    try {
      const endpoints = [
        { key: "food", url: "food/order" },
        { key: "dine", url: "food/dine" },
        { key: "housekeeping", url: "requests/guest" },
        { key: "spa", url: "spa" },
        { key: "wellness", url: "wellness" },
        { key: "taxi", url: "taxi-booking" },
        { key: "emergency", url: "emergency-request" },
        { key: "complaint", url: "complaints" },
      ];

      const titleMap = {
        food: "New Food Order",
        dine: "New Dine Booking",
        housekeeping: "New Housekeeping Request",
        spa: "New Spa Booking",
        wellness: "New Wellness Booking",
        taxi: "New Taxi Request",
        emergency: "Emergency Alert",
        complaint: "New Guest Complaint",
      };

      for (const { key, url } of endpoints) {
        const res = await axios.get(url);
        const data = Array.isArray(res.data) ? res.data : [];

        const prevCount = lastCounts.current[key] || 0;

        // only trigger if count increased
        if (data.length > prevCount) {
          const newCount = data.length - prevCount;

     addNotification({
  title: titleMap[key],
  message: `${newCount} new ${key} request${newCount > 1 ? "s" : ""} received.`,
  type: "info",
  isNew: true
});


          playSound();
        }

        // update latest count
        lastCounts.current[key] = data.length;
      }
    } catch (err) {
      console.error("Error checking service updates:", err);
    }
  };

  useEffect(() => {
    checkNewRequests(); // initial baseline
    const interval = setInterval(checkNewRequests, 7000); // every 7 seconds
    return () => clearInterval(interval);
  }, []);

  return null; // invisible watcher
};

export default GlobalNotificationWatcher;
